var map = {
	"./icon-blog.svg": 65150,
	"./icon-case-study.svg": 63582,
	"./icon-event.svg": 28890,
	"./icon-white-paper.svg": 98728,
	"./images/Content-Hover.svg": 26583,
	"./images/Content-Normal.svg": 17214,
	"./images/Data-Hover.svg": 66718,
	"./images/Data-Normal.svg": 20913,
	"./images/Devops-Hover.svg": 95349,
	"./images/Devops-Normal.svg": 8640,
	"./images/EComm-Hover.svg": 13037,
	"./images/EComm-Normal.svg": 16840,
	"./images/Managed-Hover.svg": 20235,
	"./images/Managed-Normal.svg": 64690,
	"./images/Mobility-Hover.svg": 49985,
	"./images/Mobility-Normal.svg": 45244,
	"./images/QE-Hover.svg": 73836,
	"./images/QE-Normal.svg": 73091,
	"./logos/GSPANN-Logo.svg": 20834,
	"./plug.svg": 55266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64828;